module.exports = __webpack_public_path__ + "static/img/celoscope-detail-30.01bdfd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-30.jpg
// module id = xmE7
// module chunks = 51